import React from 'react';
import ReactDOM from 'react-dom/client';
import { PedidosApp } from './PedidosApp';
import './styles/styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PedidosApp />
);


